import { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./styles.scss";
import Button from "../../../../components/Button/component";
import Filter from "../Filter/component";
import { FILTERS, FILTER_ICON } from "./constants";
import DropDown from "../../../../components/DropDown/component";
import {
    update_sports_schedule_filter_bar,
    update_sports_schedule_drop_down_list,
} from "../../../../actions/Schedule/actions";
import { useHistory, useLocation } from "react-router-dom";
import { QUERY_PARAM_SPORT } from "../MainSchedule/constants";

const FilterIcon = <img src={FILTER_ICON.src} alt="" />;

const FilterBarTitle = () => (
    <Fragment>
        {FilterIcon}
        <span className="filterBarTitle">Filter By</span>
    </Fragment>
);

const ResetButton = ({ stateKey }) => {
    const dispatch = useDispatch();
    const onClick = () => {
        dispatch(
            update_sports_schedule_filter_bar(stateKey, {
                isMedal: false,
                isTeamCanada: false,
                type: "",
            })
        );
        dispatch(update_sports_schedule_drop_down_list(stateKey));
    };
    return (
        <Button className="resetButton" onClick={onClick} label="Reset All" />
    );
};

// Displays filter bar on mobile
const DisplayFilterButton = ({ onClick }) => (
    <button
        onClick={onClick}
        className="showFiltersButton"
        data-testid="show-filters-button"
    >
        {FilterIcon}
        <span className="showFiltersLabel">Show Filters</span>
    </button>
);

// Hides filter bar on mobile
const HideButton = ({ onClick }) => (
    <Button className="hideButton" onClick={onClick} label="Hide" />
);

//updates the url search param ?sport=Rugby to match the filter
export const updateSportSearchParam = (location, history, option) => {
    const searchParams = new URLSearchParams(location.search);
    if (option !== "" && option !== searchParams.get(QUERY_PARAM_SPORT)) {
        searchParams.set(QUERY_PARAM_SPORT, option);
        location.search = searchParams.toString();
        history.push(location);
    } else if (
        option === "" &&
        searchParams &&
        searchParams.size > 0 &&
        searchParams.get(QUERY_PARAM_SPORT) !== ""
    ) {
        searchParams.delete(QUERY_PARAM_SPORT);
        location.search = searchParams.toString();
        history.push(location);
    }
};

const DropDownFilter = ({ stateKey }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(update_sports_schedule_drop_down_list(stateKey));
    }, []);
    const history = useHistory();
    const location = useLocation();
    const [initialRender, setInitialRender] = useState(true);
    const sport = useSelector((state) => {
        return state.schedule[stateKey]?.filterBar?.type || "";
    });
    const dropDownList = useSelector((state) => {
        return state.schedule[stateKey]?.dropDownList || [];
    });
    const setSport = (option) => {
        dispatch(update_sports_schedule_filter_bar(stateKey, { type: option }));
        if (initialRender) {
            setInitialRender(false);
        } else {
            updateSportSearchParam(location, history, option);
        }
    };
    return (
        <DropDown
            defaultSelection={sport || "Select A Sport"}
            options={dropDownList}
            setSelectedOption={setSport}
            className={"sportDropDown"}
            accessibilityLabelString={"Sports"}
            accessibilityKey={"sports-filter"}
        />
    );
};

const MedalFilter = ({ stateKey }) => {
    const dispatch = useDispatch();
    const medalChecked = useSelector((state) => {
        return state.schedule[stateKey]?.filterBar?.isMedal || false;
    });
    const setMedalChecked = () => {
        dispatch(
            update_sports_schedule_filter_bar(stateKey, {
                isMedal: !medalChecked,
            })
        );
    };
    return (
        <Filter
            value={medalChecked}
            toggle={setMedalChecked}
            {...FILTERS.MEDAL}
        />
    );
};

const TeamFilter = ({ stateKey }) => {
    const dispatch = useDispatch();
    const teamCanadaChecked = useSelector((state) => {
        return state.schedule[stateKey]?.filterBar?.isTeamCanada || false;
    });
    const setTeamCanadaChecked = () => {
        dispatch(
            update_sports_schedule_filter_bar(stateKey, {
                isTeamCanada: !teamCanadaChecked,
            })
        );
    };
    return (
        <Filter
            value={teamCanadaChecked}
            toggle={setTeamCanadaChecked}
            {...FILTERS.TEAM_CANADA}
        />
    );
};

const FilterBar = ({ stateKey }) => {
    const [showFilters, setShowFilters] = useState(false);

    const handleToggleFilters = () => {
        setShowFilters(!showFilters);
    };

    const showFiltersClass = showFilters ? "showFilterBar" : "hideFilterBar";
    const showFiltersButton = showFilters ? "hideButton" : "";
    const hideOlympics = useSelector(
        (state) => state.schedule[stateKey]?.filterBar?.hideOlympics
    );

    return (
        <div className="filterBarContainer" data-testid="filter-bar-container">
            <div
                className={`toggleFilterBar ${showFiltersButton}`}
                data-testid="button-container"
            >
                <DisplayFilterButton onClick={handleToggleFilters} />
            </div>
            <div
                className={`filterBar ${showFiltersClass}`}
                data-testid="filter-bar"
            >
                <div className="header">
                    <FilterBarTitle />
                    <ResetButton stateKey={stateKey} />
                </div>
                <div className="filters">
                    <DropDownFilter stateKey={stateKey} />
                    {hideOlympics || (
                        <div className="toggleFilters">
                            <MedalFilter stateKey={stateKey} />
                            <span className="separator"></span>
                            <TeamFilter stateKey={stateKey} />
                        </div>
                    )}
                </div>
                <div className="mobileButtons">
                    <ResetButton stateKey={stateKey} />
                    <HideButton onClick={handleToggleFilters} />
                </div>
            </div>
        </div>
    );
};

export default FilterBar;
